import React from 'react';
export class BaseField extends React.Component {
    constructor(props) {
        super(props);

    }

    renderErrorMessage(){
        let message = '';
        if(!this.props.IsValid){
            message = this.props.ErrorMessage;
        }
        return(
            <span className="errorMessage">
                {message}
            </span>
        )
    }

    renderLabelText(){
        let label = this.props.Label;
        if(this.props.Required){
            label += ' *';
        }
        return label;
    }

}
export default BaseField;